export enum OnlyInStock {
  ViewAll = "ViewAll",
  CountryRegionStock = "CountryRegionStock",
  MyStoreStock = "MyStoreStock",
}
